import { ListItem, ListItemButton, ListItemIcon, ListItemText, Typography, SxProps } from '@mui/material';
import { useLocation } from 'react-router-dom';
import React from 'react';
interface NavListItemProps {
  horizontal?: boolean;
  text: string | React.ReactNode;
  activeIcon: string | React.ReactElement;
  inactiveIcon: string | React.ReactElement;
  onClick?: () => void;
  activePathPatterns: string[];
  sx?: SxProps;
  children?: React.ReactNode;
}

const renderIcon = (icon: string | React.ReactElement) => {
  if (typeof icon === 'string') {
    return <img src={icon} alt="Navigation icon" style={{ width: '25px', backgroundColor: 'transparent' }} />;
  }
  return React.cloneElement(icon, { style: { fontSize: '1.6em' } });
};

const renderText = (text: string | React.ReactNode) => {
  if (typeof text === 'string') {
    return text;
  }
  return text;
}

export const NavListItem = ({ 
  horizontal = false,
  text, 
  activeIcon, 
  inactiveIcon, 
  onClick, 
  activePathPatterns,
  children,
  sx 
}: NavListItemProps) => {
  const location = useLocation();
  
  const isActive = activePathPatterns.length === 0 || activePathPatterns.some(pattern =>
    location.pathname === pattern
    || (location.pathname.match(pattern) && pattern !== '/')
    || (location.pathname.startsWith(pattern) && pattern !== '/')
  );

  const getListItemStyles = (customSx?: SxProps): SxProps => ({
    '&:hover': {
      backgroundColor: 'rgba(0, 107, 215, 0.1)',
      cursor: 'pointer'
    },
    borderRadius: '9px',
    textWrap: 'auto',
    ...customSx
  });

  const getListItemButtonStyles = {
    display: 'flex',
    flexDirection: horizontal ? 'row' : 'column',
    textDecoration: "none",
    textAlign: "center",
    width: '20px',
  };
  
  const getListItemTextStyles = {
    fontSize:  horizontal ? '14px' : '10px',
    fontWeight: isActive ? 600 : 400,
    lineHeight:   horizontal ? '17px' : '13.44px',
    textAlign: 'left'
  };

  return (
    <ListItem
      disablePadding
      sx={getListItemStyles(sx)}
    >
      <ListItemButton
        onClick={onClick}
        sx={getListItemButtonStyles}
      >
        <ListItemIcon sx={{
          minWidth: 'inherit',
          marginBottom: '1px',
          px: '5px',
          backgroundColor: 'transparent',
          '& img': {
            backgroundColor: 'transparent',
          }
        }}>
          {renderIcon(isActive ? activeIcon : inactiveIcon)}
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography
              sx={getListItemTextStyles}
            >
              {renderText(text)}
            </Typography>
          }
          style={{
            display: 'flex',
            color: isActive ? '#006BD7' : ''
          }}
        />
        {children}
      </ListItemButton>
    </ListItem>
  );
}; 